<template>
    <div id="asset_feature_category_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="assetFeatureCategoryHeader"  v-if="$route.params.id > 0">Update Asset Feature Category</span>
                    <span class="page-title" id="assetFeatureCategoryHeader"  v-else>Add Asset Feature Category</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackAssetFeatureCategoryList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="AssetFeatureCategoryForm">
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                        <div class="field-error">{{name_error_msg}}</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateAssetFeatureCategoryBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateAssetFeatureCategory" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateAssetFeatureCategoryBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateAssetFeatureCategory" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueAssetFeatureCategoryBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateAssetFeatureCategory(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelAssetFeatureCategoryBtn" class="btn btn-tertiary" v-on:click.prevent="BackAssetFeatureCategoryList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
export default {
  name: "AssetFeatureCategoryCreate",
  mixins:[commonMixins],
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Asset Feature Category | " +process.env.COPYRIGHT_NAME : "Create Asset Feature Category | " +process.env.COPYRIGHT_NAME}
  },
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    name: "",
    loading:false,
    name_error_msg: "",
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_asset_feature_category') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        
        var path = window.location.pathname;
        var segments = path.split("/");
        if (segments[3]) {
            self.loadAssetFeatureCategory();
        }
  },
  methods: {
    BackAssetFeatureCategoryList() {
      var self = this;
      self.$router.push("/assetfeaturecategory/list");
    },

    CreateAssetFeatureCategory(flag) {
      var self = this;

      self.name = self.name.trim();

      self.name_error_msg = "";

      if (!self.name || self.name == null || self.name == "") {
        self.name_error_msg = "Name Required.";
      }

      
      if (self.name_error_msg == "") {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#CreateAssetFeatureCategoryBtn").val("Updating ...");
                $("#CreateAssetFeatureCategoryBtn").prop("disabled", true);
                $("#cancelAssetFeatureCategoryBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueAssetFeatureCategoryBtn").val("Saving ...");
                    $("#CreateAssetFeatureCategoryBtn").prop("disabled", true);
                    $("#createAndContinueAssetFeatureCategoryBtn").prop("disabled", true);
                    $("#cancelAssetFeatureCategoryBtn").prop("disabled",true);

                }else{

                    $("#CreateAssetFeatureCategoryBtn").val("Saving ...");
                    $("#CreateAssetFeatureCategoryBtn").prop("disabled", true);
                    $("#createAndContinueAssetFeatureCategoryBtn").prop("disabled", true);
                    $("#cancelAssetFeatureCategoryBtn").prop("disabled",true);
                }
               
            }
            
            $.ajax({
                url: process.env.ROOT_API + "/assetfeaturecategory/create",
                type: "POST",
                data: {name: self.name, id: segments[3]},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateAssetFeatureCategoryBtn").val("Update");
                        $("#CreateAssetFeatureCategoryBtn").prop("disabled", false);
                        $("#cancelAssetFeatureCategoryBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueAssetFeatureCategoryBtn").val("Save and Continue");
                            $("#CreateAssetFeatureCategoryBtn").prop("disabled", false);
                            $("#createAndContinueAssetFeatureCategoryBtn").prop("disabled", false);
                            $("#cancelAssetFeatureCategoryBtn").prop("disabled",false);

                        }else{

                            $("#CreateAssetFeatureCategoryBtn").val("Save");
                            $("#CreateAssetFeatureCategoryBtn").prop("disabled", false);
                            $("#createAndContinueAssetFeatureCategoryBtn").prop("disabled", false);
                            $("#cancelAssetFeatureCategoryBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#AssetFeatureCategoryForm").trigger("reset");
                            self.name ="";
                    
                        }else{
                            self.$router.push("/assetfeaturecategory/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateAssetFeatureCategoryBtn").val("Update");
                        $("#CreateAssetFeatureCategoryBtn").prop("disabled", false);
                        $("#cancelAssetFeatureCategoryBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#AssetFeatureCategoryForm").trigger("reset");
                            

                            $("#createAndContinueAssetFeatureCategoryBtn").val("Save and Continue");
                            $("#CreateAssetFeatureCategoryBtn").prop("disabled", false);
                            $("#createAndContinueAssetFeatureCategoryBtn").prop("disabled", false);
                            $("#cancelAssetFeatureCategoryBtn").prop("disabled",false);

                        }else{

                            $("#CreateAssetFeatureCategoryBtn").val("Save");
                            $("#CreateAssetFeatureCategoryBtn").prop("disabled", false);
                            $("#createAndContinueAssetFeatureCategoryBtn").prop("disabled", false);
                            $("#cancelAssetFeatureCategoryBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'feature-cate-create')
                }
            });
      }else{
          self.errorValidationFocus();
      }
    },

    loadAssetFeatureCategory() {

        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        
        $.ajax({
            url: process.env.ROOT_API + "/assetfeaturecategory/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {

                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.name = data.content.name;
                } 
            },
            error: function (jqXHR, exception) {
                
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'feature-cate-by-id')
            }
        });
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/AssetFeatureCategoryCreate.vue